// extracted by mini-css-extract-plugin
export default {"form_label":"input_form_label__itlP6","formControl":"input_formControl__Xpu6s","error":"input_error__XM2YG","required":"input_required__Za+St"};